import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { ApiMethod } from '../../apimethods/api-method';
declare var $;

@Component({
  selector: 'pra-journal-config',
  templateUrl: './PRA-Journal-Config.component.html',
  styleUrls: ['./PRA-Journal-Config.component.css']
})
/** journalmapping component*/
export class journalmappingComponent {
  /** journalmapping ctor */

  showModal: boolean;
  title: string;
  dataTable: any;
  dtOptions: any;
  UserList: any;
  tableData = [];
  @ViewChild('dataTable', { static: false }) table;
  dataSet: any;

  constructor() {
    localStorage.aEID = 0;

  }
  ngOnInit(): void {
    $("#ddlPrimaryUser").select2({
      placeholder: "Select User", dropdownParent: "#divFormPanel", multiple: true
    });
    $("#ddlSecondUser").select2({
      placeholder: "Select User", dropdownParent: "#divFormPanel", multiple: true
    });
    this.GetPraUserList();
    this.getjournalmappingList();
  }
  GetPraUserList(): void {
    let leadId = $('#ddlKPITeamLead').val();
    ApiMethod.getMethod('/api/pra/userlist/false/0').subscribe(
      result => {
        this.UserList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
  getjournalmappingList(): void {
    $("#LoadingImage").show();
    var dashboardPostData = {
      LoginID: localStorage.aLoginID,
      PublisherID: $("#ddlKPIPulisher").val(),
    };
    ApiMethod.postMethod('pra/PRAJournalConfig', dashboardPostData).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.dataSet = JSON.stringify(result.datalist); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);
        //Dynamic datable
        let aColList = result.collist;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'PRA Journal Config';
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  clearData(): void {
    let form: NgForm = $('form#frmJrnlConfig');
    form[0].reset();
    $('#ddlJournalType').val("Open Access").change();
    $('#ddlAllocationType').val("Single").change();
    $('#ddlPrimaryUser').val("").change();
    $('#ddlSecondUser').val("").change();

  }

  //Show Status control popup
  show(): void {
    this.clearData();
    if (localStorage.aEID != 0) {
      $("#LoadingImage").show();
      ApiMethod.getMethod('pra/JournalUser/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImage").hide();
          let itemL = result.datalist;
          let selectedPrim = new Array();

          try {
            let dataPUser = itemL[0].PrimaryUserID.split(',');

            for (var k = 0; k < dataPUser.length; k++) {
              selectedPrim[k] = dataPUser[k];
            }

          } catch (e) {
            console.log(e);
          }
          let selectedSecond = new Array();

          try {
            let dataSUser = itemL[0].SecondaryUserID.split(',');

            for (var k = 0; k < dataSUser.length; k++) {
              selectedSecond[k] = dataSUser[k];
            }

          } catch (e) {
            console.log(e);
          }
          $('#txtJournalCode').val(itemL[0].JournalCode);
          $('#txtJournalName').val(itemL[0].JournalName);
          $('#ddlJournalType').val(itemL[0].JournalType).change();
          $('#ddlAllocationType').val(itemL[0].AllocationFlow).change();
          $('#ddlPrimaryUser').val(selectedPrim).change();
          $('#ddlSecondUser').val(selectedSecond).change();
        },
        error => {
          ngswal("Failed !", error.message, "warning");
        }
      );
    }
    this.showModal = true; // Show-Hide Modal Check
    this.title = "Journal User Config";    // Dynamic Data
  }

  //Bootstrap Modal Close event
  hide() {
    this.clearData();
    this.showModal = false;
  }

  //Update Status details method
  updateJournalConfigDetails(): void {
    if ($('#txtJournalCode').val().trim() == '') {
      ngswal("Warning !", "Enter Journal Code !", "warning");
    }
    else if ($('#txtJournalName').val().trim() == '') {
      ngswal("Warning !", "Enter Journal Title !", "warning");
    }
    else if ($('#ddlAllocationType').val() == "Single" && ($('#ddlPrimaryUser').val().toString().includes(',') || $('#ddlSecondUser').val().toString().includes(','))) {
      ngswal("Warning !", "Select Single User for both Primary and Secondary Mapping !", "warning");
    }
    else {
      $("#LoadingImagePopup").show();
      var aitemL = {
        Id: localStorage.aEID,
        JournalCode: $('#txtJournalCode').val(),
        JournalName: $('#txtJournalName').val(),
        JournalType: $('#ddlJournalType').val(),
        AllocationFlow: $('#ddlAllocationType').val(),
        PrimaryUserID: $('#ddlPrimaryUser').val().toString(),
        SecondaryUserID: $('#ddlSecondUser').val().toString(),
        UpdatedBy: localStorage.aLoginID,
      };
      ApiMethod.postMethod('pra/updateJUconfig', aitemL).subscribe(
        response => {
          this.getjournalmappingList();
          $("#LoadingImagePopup").hide();
          this.hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }

  Delete() {
    ngswal({
      title: "Are you sure to delete Journal?",
      text: "Jorunal will be deleted permenently",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnDeleteConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel!", "warning");
        }
      });
  }

  DeleteConfirm() {
    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    var data = {
      LoginID: localStorage.aLoginID,
      Id: localStorage.aEID
    };
    ApiMethod.postMethod('pra/deletejournal', data).subscribe(
      result => {
        if (result.status == false) {
          ngswal("Failed !", result.message, "warning");
        }
        else {
          ngswal("Success !", result.message, "info");
          this.getjournalmappingList();
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

}
